import React, { useState, useEffect } from "react";

import cdesApi from "apis/cdeDefinitions";
import survivorshipDomainBusinessRulesApi from "apis/survivorshipDomainBusinessRules";
import survivorDomainRecordApi from "apis/survivorshipDomainRecord";
import { SubHeader, PageLoader, Typography } from "clearsense-ui/components";
import { EmptyState } from "components/Common";

import SearchNPI from "./SearchNPI";
import Tabs from "./Tabs";

import { formatDataForSurvivorshipDomainDetailsTable } from "../utils";

const RecordDetails = () => {
  const [isNPILoading, setIsNPILoading] = useState(false);
  const [recordDetails, setRecordDetails] = useState([]);
  const [searchIdentifier, setSearchIdentifier] = useState("");
  const [tableData, setTableData] = useState([]);
  const [cdeFilters, setCdeFilters] = useState([]);
  const [cdes, setCdes] = useState([]);
  const [businessRules, setBusinessRules] = useState([]);

  const fetchCDEs = async () => {
    try {
      const { data } = await cdesApi.fetchCdes("", 1, 100);
      setCdes(data.cde_definitions.cdes.map(({ name }) => name));
    } catch (err) {
      logger.log(err);
    }
  };

  const fetchBusinessRules = async () => {
    try {
      const { data } = await survivorshipDomainBusinessRulesApi.fetchRules(
        1,
        999
      );
      setBusinessRules(
        data.business_rules
          .filter(
            businessRule => businessRule.business_rule_category === "Trust Rule"
          )
          .reduce(
            (acc, { critical_data_element, business_rule }) => ({
              ...acc,
              [critical_data_element]: business_rule,
            }),
            {}
          )
      );
    } catch (err) {
      logger.log(err);
    }
  };

  useEffect(() => {
    fetchCDEs();
    fetchBusinessRules();
  }, []);

  const handleSearch = async npi => {
    setSearchIdentifier({ context_value: npi });
    setIsNPILoading(true);
    setCdeFilters([]);
    try {
      const { data } = await survivorDomainRecordApi.fetchNPI(npi);
      setSearchIdentifier(prev => ({
        ...prev,
        context_cde: data?.result?.[0]?.context_cde,
      }));
      delete data?.result?.[0]?.context_cde;
      delete data?.result?.[0]?.context_value;
      if (data.result.length) {
        setRecordDetails(data);
        const formattedData = formatDataForSurvivorshipDomainDetailsTable(
          data,
          cdeFilters,
          Object.keys(data?.result?.[0])
        );
        setTableData(formattedData);
      } else {
        setRecordDetails({});
      }
    } catch (err) {
      logger.log(err);
    } finally {
      setIsNPILoading(false);
    }
  };

  return (
    <div className="cs-ui-container px-8 space-y-8">
      <SubHeader
        breadcrumbs={[{ label: "Trust Rules Record Details", link: "#" }]}
        className="mt-8"
      />
      <div>
        <SearchNPI isNPILoading={isNPILoading} handleSearch={handleSearch} />
        {searchIdentifier.context_value && (
          <Typography style="h5" className="italic">
            {`Your search results for "`}
            <span className="font-semibold">
              {searchIdentifier.context_value}
            </span>
            {`"`}
          </Typography>
        )}
      </div>
      {!Object.keys(recordDetails)?.length &&
        searchIdentifier.context_value &&
        !isNPILoading && <EmptyState mainText="No Record Found" />}
      {isNPILoading && <PageLoader />}
      {!!Object.keys(recordDetails)?.length && !isNPILoading && (
        <Tabs
          recordDetails={recordDetails}
          searchIdentifier={searchIdentifier}
          tableData={tableData}
          cdeFilters={cdeFilters}
          cdes={cdes}
          businessRules={businessRules}
          setTableData={setTableData}
          setCdeFilters={setCdeFilters}
        />
      )}
    </div>
  );
};

export default RecordDetails;
